//
import EmployeeModel from '@/models/HumanResource/HrEmployee'

//
export default [
    {
        name: 'period_year',
        picker: {
            activePicker: 'YEAR',
        },
        props: {
            label: 'Periodo',
            suffix: 'Año',
        },
        type: 'text-field',
        value: '',
    },
    {
        name: 'normal_holidays',
        props: {
            clearable: true,
            items: [
                {
                    text: 'No',
                    value: false,
                },
                {
                    text: 'Si',
                    value: true,
                },
            ],
            label: 'Vacaciones normales',
            singleLine: false,
        },
        noPrepend: true,
        type: 'select',
        value: '',
    },
    {
        name: 'disabled_period',
        props: {
            clearable: true,
            items: [
                {
                    text: 'No',
                    value: false,
                },
                {
                    text: 'Si',
                    value: true,
                },
            ],
            label: 'Periodo deshabilitado',
            singleLine: false,
        },
        noPrepend: true,
        type: 'select',
        value: '',
    },
    {
        name: 'hr_employee_id',
        props: {
            itemText: ({ names, last_name1, last_name2 }) => [ names, last_name1, last_name2 ].join( ' ' ),
            itemValue: 'id',
            label: 'Empleado',
            model: EmployeeModel,
            noObject: true,
            paramSearch: 'names',
            suffix: 'Año',
        },
        type: 'autocomplete-model',
        value: [],
    },
]